import axios from 'axios';

class UniversityService {
  getAll() {
    return axios.get('/university/all');
  }

  create(data) {
    return axios.post('/university', data);
  }

  update(id, data) {
    return axios.put(`/university/${id}`, data);
  }

  delete(id) {
    return axios.delete(`/university/${id}`);
  }

  get(id) {
    return axios.get(`/university/${id}`);
  }

  updateUniAdmin(data) {
    return axios.post(`/university/updateUniAdmin`, data);
  }

  createUniGroup(data) {
    return axios.post(`/university/create-uni-group`, data);
  }

  createUniRule(data) {
    return axios.post(`/university/create-uni-rule`, data);
  }

  updateUniversitiesInGroup(data) {
    return axios.post(`/university/updateUniversitiesInGroup`, data);
  }

  updateUniGroup(data) {
    return axios.post(`/university/updateUniGroup`, data);
  }

  deleteGroup(id) {
    return axios.delete(`/university/delete-group/${id}`);
  }

  findAllGroups() {
    return axios.get('/university/groups/all-groups');
  }

  findAllGroupRules() {
    return axios.get('/university/groups/all-group-rules');
  }

  updateGroupRule(data) {
    return axios.post('/university/groups/update-rule', data);
  }
}

export default new UniversityService();
